import { useContext } from 'react';
import { Context } from './Context';
export const useApprovalCheck = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useApprovalCheck hook used outside <ApprovalCheckProvider />');
    }
    return context;
};
